import { XIcon } from '@heroicons/react/outline'
import { useEffect, useState } from 'react'

function SuccessAlert({ success }) {
    const [hide, setHide] = useState(false)

    useEffect(() => {
        // setTimeout(() => {
        //     sethide(true)
        // }, 5000)

        setHide(success == '' ? true : false) // if success is empty then hide the alert
    }, [success])

    if (hide) return null

    return (
        <div className="rounded-md bg-green-50 border border-green-300 p-4">
            <div className="flex">
                <div className="ml-3 flex-1 md:flex md:justify-between">
                    <p className="">{success}</p>
                    <XIcon
                        onClick={() => setHide(true)}
                        className="h-5 w-5 text-green-400 hover:text-green-500 cursor-pointer"
                        aria-hidden="true"
                    />
                </div>
            </div>
        </div>
    )
}

export default SuccessAlert
